import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { NgbAccordionModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { AppConfig } from 'src/app/app-config.service';
import { Tool } from '../../models/tool.model';
import { WindowHelper } from 'src/app/shared/utilities/helpers/window-helper/window-helper';
import { ContactsBlockComponent } from 'src/app/shared/components/contacts-block/contacts-block.component';
import { FacetChipsComponent } from 'src/app/shared/components/facet-chips/facet-chips.component';
import { ImageCarouselComponent } from 'src/app/shared/components/image-carousel/image-carousel.component';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';
import { UserService } from 'src/app/shared/services/user.service';
import normalizeNbsp from 'src/app/shared/utilities/helpers/string-helpers';

@Component({
  selector: 'app-tools-modal',
  templateUrl: './tools-modal.component.html',
  styleUrl: './tools-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule, 
    ContactsBlockComponent,
    ImageCarouselComponent,
    MatChipsModule,
    MatIconModule,
    FacetChipsComponent, 
    NgbAccordionModule,
    NgbTooltipModule,
    SafeHtmlPipe
  ]
 })

export class ToolsModalComponent implements OnInit, OnDestroy {
  cdnUrl: string = AppConfig.settings.cdnUrl;
  baseUrl: string = window.location.origin + '/';

  displayedFacets: string[][] = [];

  imageUrls: string[] = [];
  galleryImageUrls: string[] = [];

  activeIndex: number = 0;

  tool?: Tool = inject(MAT_DIALOG_DATA) as Tool;

  private readonly userService = inject(UserService);
  private readonly location = inject(Location);
  private readonly dialogRef: MatDialogRef<ToolsModalComponent> = inject<MatDialogRef<ToolsModalComponent>>(MatDialogRef);
  private readonly windowHelper = inject(WindowHelper);

  isAdmin = this.userService.isAdmin;

  ngOnInit(): void {
    if (this.tool){
      this.tool.description = normalizeNbsp(this.tool.description);
      this.tool.specialCondition = normalizeNbsp(this.tool.specialCondition);
      
      this.formatImages();
      this.updateFacets(this.tool);
    }
  }

  updateFacets(tool: Tool){
    const facets: string[][] = [];

    if (tool.lifeCyclePhases) tool.lifeCyclePhases.forEach(p => facets.push(["lifecycle", p]));
    if (tool.personas && tool.personas.length > 0) tool.personas.forEach(p => facets.push(["persona", p]));
    if (tool.toolTypes && tool.toolTypes.length > 0) tool.toolTypes.forEach(t => facets.push(["tooltype", t]));
    this.displayedFacets = facets;
  }

  formatImages(): void {
    this.imageUrls = (this.tool?.galleryReferences ?? [])
      .map(reference => {
        const id = this.tool!.id
        return `${this.cdnUrl}/tools-thumbnail/${id}/${reference}`;
      });

    this.galleryImageUrls = (this.tool?.galleryReferences ?? [])
      .map(reference => {
        const id = this.tool!.id
        return `${this.cdnUrl}/tools-gallery/${id}/${reference}`;
      });
  }

  onClose(): void {
    this.dialogRef.close();
    this.location.historyGo(-1);
  }
   
  ngOnDestroy(): void {
    if(this.windowHelper.getLocationHref().includes('Id')){
      this.location.historyGo(-1);
    }
  }
}